import { render, staticRenderFns } from "./ShareLink.vue?vue&type=template&id=24c639a0&scoped=true&"
import script from "./ShareLink.vue?vue&type=script&lang=js&"
export * from "./ShareLink.vue?vue&type=script&lang=js&"
import style0 from "./ShareLink.vue?vue&type=style&index=0&id=24c639a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c639a0",
  null
  
)

export default component.exports